import { useRouter } from 'next/router';
import { JOB_COUNT_PER_PAGE } from 'constants/jobList';
import { JOB_SEARCH_LIST_REQUEST_QUERY_PARAM_KEYS } from '../constants';
import { generateCreatePageHref } from '../logics/generateCreatePageHref';

/** usePager Props*/
interface UsePagerArgs {
  /** 全体の件数 */
  totalCount?: number;
  /** 現在のページ番号 */
  currentPage: number;
  /** 特集枠ID */
  featuredId: string;
}

const SEARCH_PARAMS_SET = new Set(JOB_SEARCH_LIST_REQUEST_QUERY_PARAM_KEYS);

/**
 * ページャーのフックを定義
 *
 * @param {UsePagerArgs} args - 引数のオブジェクト
 * @param {number} args.totalCount - 全体の件数
 * @param {number} args.currentPage - 現在のページ番号
 * @param {string} args.featuredId - 特集枠ID
 * @returns {{maxPage: number, currentPage: number, createPageHref: (pageNum: number) => string}} ページャー関連のデータと関数を返すオブジェクト
 */
export const usePager = ({
  totalCount,
  currentPage,
  featuredId,
}: UsePagerArgs) => {
  const router = useRouter();
  const maxPage = totalCount ? Math.ceil(totalCount / JOB_COUNT_PER_PAGE) : 0;

  const hasSearchParams = Object.keys(router.query).some((key) =>
    SEARCH_PARAMS_SET.has(key)
  );

  const createPageHref = generateCreatePageHref({
    hasSearchParams,
    featuredId,
    currentUrl: router.asPath,
  });

  return {
    maxPage,
    currentPage,
    createPageHref,
  };
};
